import React, { Component } from 'react';
import { Input } from 'antd';

import withFormItem from 'components/hocs/withFormItem';

@withFormItem
export default class InputComponent extends Component {
    onChange = (e) => {
        const { field: { name }, form: { setFieldValue } } = this.props;

        setFieldValue(
            name,
            e.target.value
        );
    }

    render() {
        const { field: { name, value }, type, placeholder, disabled } = this.props;

        return (
            <Input
                name={name}
                type={type}
                value={value}
                onChange={this.onChange}
                placeholder={placeholder}
                disabled={disabled}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/form/Input.js